
import { LucideIcon } from "lucide-react";
import { cn } from "../../lib/utils";

interface StatCardProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  trend?: "up" | "down" | "neutral";
  change?: string;
  iconBg?: string;
}

const StatCard = ({ 
  label, 
  value, 
  icon, 
  trend = "neutral",
  change,
  iconBg = "bg-blue-50" 
}: StatCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-gray-500">{label}</p>
          <h3 className="text-2xl font-bold mt-2 text-gray-900">{value}</h3>
          
          {change && (
            <div className="mt-2 flex items-center text-sm">
              <span className={cn(
                "font-medium",
                trend === "up" ? "text-green-600" : trend === "down" ? "text-red-600" : "text-gray-500"
              )}>
                {change}
                {trend === "up" && " ↑"}
                {trend === "down" && " ↓"}
              </span>
            </div>
          )}
        </div>
        
        <div className={cn("rounded-full p-3", iconBg)}>
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
